import { useTheme } from '@mui/styles';
import { MODAL_TYPES } from 'src/shared/components/Modals';
import { showModal } from 'src/old/actions/modal/modalActions';
import HelperIcon from 'src/shared/components/HelperIcon';
import { useDispatch } from 'react-redux';
import { useStyles } from './styles';
import FreezeCardModalInformation from '../FreezeCardModalInformation';

type PostFreezeCardIconProps = {
  isSwanCard: boolean;
};

const PostFreezeCardIcon = ({ isSwanCard }: PostFreezeCardIconProps) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  const theme: any = useTheme();

  const modalProps = {
    CustomComponent: () => <FreezeCardModalInformation isSwanCard={isSwanCard} />
  };
  const handleOpenMoal = () => {
    showModal(modalProps, MODAL_TYPES.CUSTOM)(dispatch);
  };

  return (
    <div data-testid="helper-icon-wrapper" className={classes.helperIconRoot} onClick={handleOpenMoal}>
      <HelperIcon size={18} color={theme.palette.colorPalette[1]} hoverColor={theme.palette.text.primary} />
    </div>
  );
};

export default PostFreezeCardIcon;
